let urlLanguageMapping = {
  de: "de-De",
  en: "en-Us",
  uk: "en-Us",
  eu: "en-Us",
  us: "en-Us",
  fr: "fr-FR",
  it: "it-IT",
  nl: "nl-NL",
  pl: "en-US",
  es: "es-ES",
  default: "de-DE", // Default to German if no match is found
};

function getLocaleFromLanguage(language) {
  if (!language || !urlLanguageMapping[language])
    return urlLanguageMapping.default;
  return urlLanguageMapping[language];
}

function switchGorgiasLanguage() {
  let location_url = window.location.href;
  let helpCenterIframe = document.querySelector(
    "[data-gorgias-help-center-uid] iframe"
  );

  selectedLanguage = getLocaleFromLanguage(window.Shopify.locale);

  // Append language parameter to the URL
  if (helpCenterIframe) {
    let url = new URL(location_url);

    let helpCenterFixedUrl = selectedLanguage ;

    // Is the hcUrl parameter present in the URL? Used in nested articles
    const helpCenterParameters = url.searchParams.get("hcUrl");

    if (helpCenterParameters && helpCenterParameters.includes("/")) {
      // If it is an nested link, keep the nested path instead of resetting it
      const helpCenterUrlChunks = helpCenterParameters.split("/");
      helpCenterUrlChunks.shift(); // Remove the first empty string

      // Keep the rest of the chunks as they are to get to the new urls. Just bring the language.
      helpCenterUrlChunks[0] = selectedLanguage;
      helpCenterFixedUrl = helpCenterUrlChunks.join("/");
    }

    url.searchParams.set("hcUrl", "/" + helpCenterFixedUrl);
    // window.history.replaceState({}, "", url); // legacy code. I don't know if it is necessary

    helpCenterIframe.src = replacePathInUrl(
      helpCenterIframe.src,
      helpCenterFixedUrl
    );
  }
}

function replacePathInUrl(url, newPathValue) {
  try {
    let parsedUrl = new URL(url);

    parsedUrl.searchParams.set("path", `/${newPathValue}`);

    return parsedUrl.toString();
  } catch (error) {
    console.error("Invalid URL provided", error);
    return url;
  }
}

window.addEventListener("load", function () {
  switchGorgiasLanguage();

  let collectionSlider = document.querySelector(
    ".collection-filters__wrapper.carousel"
  );
  if (collectionSlider) {
    let flickConfig = JSON.parse(
      collectionSlider.getAttribute("data-flickity")
    );
    let flkty = new Flickity(
      ".collection-filters__wrapper.carousel",
      flickConfig
    );
    flkty.destroy();
    flkty = new Flickity(".collection-filters__wrapper.carousel", flickConfig);
    flkty.resize();
  }
});
